import React from 'react';
import { Cancel } from '@mui/icons-material';
import StripeIntegration from './StripeIntegration';
import QuickBooksIntegration from './QuickBooksIntegration';
import GoogleCalendarIntegration from './GoogleCalendarIntegration';
import GoogleDriveIntegration from './GoogleDriveIntegration';
import MailchimpIntegration from './MailchimpIntegration';
import HubSpotIntegration from './HubSpotIntegration';
import FinancialPartnerIntegration from './FinancialPartnerIntegration';

interface IntegrationModalProps {
  isOpen: boolean;
  integrationId: string;
  communityId: string;
  userId: string;
  onClose: () => void;
  onStatusChange?: () => void;
}

const IntegrationModal: React.FC<IntegrationModalProps> = ({
  isOpen,
  integrationId,
  communityId,
  userId,
  onClose,
  onStatusChange,
}) => {
  const renderIntegrationComponent = () => {
    switch (integrationId) {
      case 'stripe':
        return <StripeIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'quickbooks':
        return <QuickBooksIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'google_calendar':
        return <GoogleCalendarIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'google_drive':
        return <GoogleDriveIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'mailchimp':
        return <MailchimpIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'hubspot':
        return <HubSpotIntegration communityId={communityId} userId={userId} onClose={onClose} />;
      case 'airiwheels':
        return (
          <FinancialPartnerIntegration
            communityId={communityId}
            userId={userId}
            onClose={onClose}
            onStatusChange={onStatusChange}
          />
        );
      default:
        return <div>Integration not found</div>;
    }
  };

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={onClose}></div>
      <dialog
        data-testid="integration-modal"
        className="z-50 w-full max-w-4xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={onClose}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <span onClick={onClose} className="ml-auto w-full flex cursor-pointer mb-4">
            <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          {renderIntegrationComponent()}
        </div>
      </dialog>
    </div>
  );
};

export default IntegrationModal;
